import { render } from "./entertainment.vue?vue&type=template&id=0e4b3890&scoped=true"
import script from "./entertainment.vue?vue&type=script&lang=js"
export * from "./entertainment.vue?vue&type=script&lang=js"

import "./entertainment.vue?vue&type=style&index=0&id=0e4b3890&lang=scss&scoped=true"

import exportComponent from "E:\\Gitlab\\02_各园区PC端\\happyHarbour\\ningbo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e4b3890"]])

export default __exports__